export enum ProposalSuccessEnum {
  ADD_TOKEN,
  REMOVE_TOKEN,
  L1_TRANSACTION,
  L2_TRANSACTION,
  CHANGE_VALIDATOR_SET,
}
